import { gql } from '@common/hooks';
import { SimpleFileFragment } from '@common/graphql';

export const WorksReverseInvoiceExportMutation = gql`
  mutation CreateWorksReverseInvoiceExportMutation(
    $id: ID!
    $format: WorksInvoiceFileFormat!
  ) {
    result: createWorksReverseInvoiceExport(
      input: { id: $id, format: $format }
    ) {
      success
    }
  }
`;

export const WorksReverseInvoicePdfExportMutation = gql`
  mutation createWorksReverseInvoicePdf($id: ID!) {
    result: createWorksReverseInvoicePdf(input: { reverseInvoiceId: $id }) {
      file {
        ...SimpleFileFragment
      }
    }
  }
  ${SimpleFileFragment}
`;

export type ExportLineItemsArgs = {
  id: string;
  format: 'tsv' | 'csv' | 'xlsx';
};

export type ExportLineItemsFileResponse = {
  result: {
    success: boolean;
  };
};

export const WorksReverseInvoiceMultipleExportMutation = gql`
  mutation CreateWorksReverseInvoiceMultipleExportMutation(
    $entityIds: [ID!]!
    $format: WorksInvoiceFileFormat!
  ) {
    result: createWorksReverseInvoiceMultipleExport(
      input: { entityIds: $entityIds, format: $format }
    ) {
      file: exportFile {
        ...SimpleFileFragment
      }
    }
  }
  ${SimpleFileFragment}
`;
